interface IProps {
  color: string
}

const SmsIcon = ({ color = '#FCF3CC' }: IProps) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' height='16' viewBox='0 96 960 960' width='16'>
      <path
        fill={color}
        d='M639 958q-8 0-16-3t-13.9-8.95L497 833q-12-12-11.5-29.5T498 774q12-12 29.5-12t29.5 12l83 84 193-193q12-12 29-12t29 12q12 12 12 29t-12 29L668.897 946.078Q663 952 655 955q-8 3-16 3ZM163 340l318 198 318-198H163Zm1 559q-34.65 0-59.325-24.675Q80 849.65 80 815V340q0-34.65 24.675-59.325Q129.35 256 164 256h632q34.65 0 59.325 24.675Q880 305.35 880 340v159l-42 42-42 42V424L501.746 607.124q-4.921 2.938-10.333 4.407Q486 613 480 613t-11.413-1.469q-5.412-1.469-10.333-4.407L164 424v391h195l84 84H164Zm316-238Zm0-123Zm0 77Z'
      />
    </svg>
  )
}

export default SmsIcon
